/*
 * @Author: wlo_o
 * @Date: 2020-07-21 15:38:52
 * @LastEditors: Jone
 * @LastEditTime: 2022-07-01 10:13:16
 * @FilePath: /frontend/lib/common/apis.js
 * @Description: 接口
 *
 * Copyright (c) 2022 by 青岛百洋智能科技股份有限公司, All Rights Reserved.
 */
import isFunction from 'lodash/isFunction'
import get from 'lodash/get'
import merge from 'lodash/merge'
import Vue from 'vue'
import { callApi, firstUpperCase } from './utils.js'

const defaultPostParams = {
  cache: 'no-cache',
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'Connection': 'keep-alive',
    'cache-control': 'no-cache',
    'pragma': 'no-cache'
  },
  method: 'POST'
}

// 默认拦截器
export const defaultFilter = params => params

// 默认过滤器
export const defaultMapping = ({ code, message = '', data }) => code === 200 ? Promise.resolve(data) : Promise.reject(message)

const commonPost = async (pathname, data = {}) => {
  let { body = {} } = data
  let prefix = get(this, 'api.prefix', '') || get(this, '$OecpMetaDataConfig.api.prefix', '')
  prefix = prefix || get(Vue.prototype, '$OecpMetaDataConfig.api.prefix', '')
  if (process.env.VUE_APP_ENABLE_MOCK === '1' || process.env.VUE_APP_ENABLE_MOCK === 'true') {
    return fetch(process.env.VUE_APP_MOCK_ORIGIN + pathname, { ...defaultPostParams, body: JSON.stringify(body || {}) }).then(response => response.json())
  }
  let options = { ...merge(defaultPostParams, data), body: JSON.stringify(body || {}) }
  return new Promise(function (resolve, reject) {
    fetch(prefix + pathname, options).then(response => {
      if (response.ok) {
        response.json().then(jsonValue => {
          resolve(jsonValue)
        }).catch(err => {
          reject(err)
        })
      } else {
        reject(new Error('oops'))
      }
    }).catch((err) => {
      reject(err)
    })
  })
  // const response = await fetch(prefix + pathname, options)
  // debugger
  // if (response.ok) {
  //   const jsonValue = await response.json()
  //   return Promise.resolve(jsonValue)
  // } else {
  //   return Promise.reject(new Error('oops'))
  // }
}

let apis = {

  /*********************
  公共分类 http://yapi.baipaas.com/project/603/interface/api/cat_9196
  *********************/
  // ★★★★☆配置信息列表（options） http://yapi.baipaas.com/project/603/interface/api/61858
  optionsList (data = {}) { return commonPost('/options/list', data) },
  // ★★★☆☆新增配置（options） http://yapi.baipaas.com/project/603/interface/api/61903
  optionsSave (data = {}) { return commonPost('/options/save', data) },

  /*********************
  分类 http://yapi.baipaas.com/project/603/interface/api/cat_9203
  *********************/
  // ★★★★★获取分类列表(category) http://yapi.baipaas.com/project/603/interface/api/61810
  categoryPageList (data = {}) { return commonPost('/category/pageList', data) },
  // 查询当前分类有无关联 http://yapi.baipaas.com/project/603/interface/api/62383
  categoryFindCategoryRelationships (data = {}) { return commonPost('/category/findCategoryRelationships', data) },
  // ★★★★★获取分类(category) http://yapi.baipaas.com/project/603/interface/api/61900
  categoryFind (data = {}) { return commonPost('/category/find', data) },
  // ★☆☆☆☆ 获取分类扩展信息(categoryExt)--可暂时不做 http://yapi.baipaas.com/project/603/interface/api/61816
  categoryExtList (data = {}) { return commonPost('/category/extList', data) },
  // ★★★☆☆新增分类 http://yapi.baipaas.com/project/603/interface/api/61864
  categorySave (data = {}) { return commonPost('/category/save', data) },
  // ★★★☆☆删除分类 http://yapi.baipaas.com/project/603/interface/api/62011
  categoryDelete (data = {}) { return commonPost('/category/delete', data) },
  // ★★★☆☆关联分类 http://yapi.baipaas.com/project/603/interface/api/62026
  categoryAddRelationship (data = {}) { return commonPost('/category/addRelationship', data) },
  // ★★★☆☆删除关联 http://yapi.baipaas.com/project/603/interface/api/62029
  categoryDelRelationship (data = {}) { return commonPost('/category/delRelationship', data) },
  // ★★★☆☆关联查询 http://yapi.baipaas.com/project/603/interface/api/62107
  categoryFindRelationship (data = {}) { return commonPost('/category/findRelationship', data) },
  // ★★★★★查询分类(category) http://yapi.baipaas.com/project/603/interface/api/62089
  categoryFindList (data = {}) { return commonPost('/category/findList', data) },

  /*********************
  元素（数据集、数据元、值域、统计指标） http://yapi.baipaas.com/project/603/interface/api/cat_9224
  *********************/
  // ★★★★★获取元素列表(element) http://yapi.baipaas.com/project/603/interface/api/61834
  elementPageList (data = {}) { return commonPost('/element/pageList', data) },
  // ★★★★☆数据集删除 http://yapi.baipaas.com/project/603/interface/api/62146
  setDelete (data = {}) { return commonPost('/set/delete', data) },
  // ★★★★☆获取元素(element) http://yapi.baipaas.com/project/603/interface/api/61894
  elementFind (data = {}) { return commonPost('/element/find', data) },
  // ★★★☆☆新增元素(element) http://yapi.baipaas.com/project/603/interface/api/61873
  elementSave (data = {}) { return commonPost('/element/save', data) },
  // ★★★☆☆删除元素(element) http://yapi.baipaas.com/project/603/interface/api/62095
  elementDelete (data = {}) { return commonPost('/element/delete', data) },
  // ★★☆☆☆统计扩展字段使用数量 http://yapi.baipaas.com/project/603/interface/api/62341
  elementFindExtCount (data = {}) { return commonPost('/element/findExtCount', data) },
  // ★★★☆☆添加关联元素 http://yapi.baipaas.com/project/603/interface/api/61906
  elementAddChildren (data = {}) { return commonPost('/element/addChildren', data) },
  // ★★★☆☆删除关联元素 http://yapi.baipaas.com/project/603/interface/api/61909
  elementDelChildren (data = {}) { return commonPost('/element/delChildren', data) },
  // ★★★☆☆查询子元素 http://yapi.baipaas.com/project/603/interface/api/61912
  elementChildrenList (data = {}) { return commonPost('/element/childrenList', data) },
  // ★★★★☆获取元素值列表(elementValue) http://yapi.baipaas.com/project/603/interface/api/61849
  elementValuesPageList (data = {}) { return commonPost('/element/values/pageList', data) },
  // ★★★☆☆新增元素值(elementValue) http://yapi.baipaas.com/project/603/interface/api/61876
  elementValuesSave (data = {}) { return commonPost('/element/values/save', data) },
  // ★★★☆☆删除元素值(elementValue) http://yapi.baipaas.com/project/603/interface/api/62122
  elementValuesDelete (data = {}) { return commonPost('/element/values/delete', data) },
  // ★☆☆☆☆获取元素扩展字段列表(elementExt) http://yapi.baipaas.com/project/603/interface/api/61840
  elementExtList (data = {}) { return commonPost('/element/extList', data) },

  /*********************
  数据集 http://yapi.baipaas.com/project/603/interface/api/cat_9238
  *********************/
  // ★★★★☆数据集列表 http://yapi.baipaas.com/project/603/interface/api/61915
  setPageList (data = {}) { return commonPost('/set/pageList', data) },
  // ★★★★☆数据集-模块列表 http://yapi.baipaas.com/project/603/interface/api/62368
  setModuleList (data = {}) { return commonPost('/set/moduleList', data) },
  // ★★★★☆数据集-模块删除 http://yapi.baipaas.com/project/603/interface/api/62371
  setModuleDelete (data = {}) { return commonPost('/set/moduleDelete', data) },
  // ★★★☆☆数据集-模块更新 http://yapi.baipaas.com/project/603/interface/api/62374
  setModuleSave (data = {}) { return commonPost('/set/moduleSave', data) },
  // ★☆☆☆☆ 获取数据集扩展(SetExt) http://yapi.baipaas.com/project/603/interface/api/62101
  setExtList (data = {}) { return commonPost('/set/extList', data) },
  // ★☆☆☆☆ 获取数据集扩展(SetExt) http://yapi.baipaas.com/project/603/interface/api/61933
  setExtSave (data = {}) { return commonPost('/set/extSave', data) },
  // ★★★★☆获取数据集 http://yapi.baipaas.com/project/603/interface/api/61918
  setFind (data = {}) { return commonPost('/set/find', data) },
  // ★★★☆☆导入到数据集 http://yapi.baipaas.com/project/603/interface/api/62059
  setAddChildren (data = {}) { return commonPost('/set/addChildren', data) },
  // ★★★☆☆删除关联元素 http://yapi.baipaas.com/project/603/interface/api/61921
  setDelChildren (data = {}) { return commonPost('/set/delChildren', data) },
  // ★★★★☆ 获取数据集内元素列表 http://yapi.baipaas.com/project/603/interface/api/61930
  elementSource (data = {}) { return commonPost('/element/source', data) },
  // ★★★☆☆新增数据集(set) http://yapi.baipaas.com/project/603/interface/api/62086
  setSave (data = {}) { return commonPost('/set/save', data) },
  
  // ★★★☆☆查询自定模板
  templateFindFullSubDataSet (data = {}) { return commonPost('/template/findFullSubDataSet', data) },
  // ★★★☆☆生成SQL
  tablesGenSqlByDataset (data = {}) { return commonPost('/tables/genSqlByDataset', data) },
  // ★★★☆☆元数据-数据集的元素接口
  setElementFind (data = {}) { return commonPost('/setElement/find', data) },


  // ★★★☆☆自定义模板 - 列表
  templatePageList (data = {}) { return commonPost('/template/pageList', data) },
  // ★★★☆☆编辑自定模板
  templateSaveFullSubDataSet (data = {}) { return commonPost('/template/saveFullSubDataSet', data) },
}

export function fetchApi (pathname, data = {}) {
  let config = Vue.prototype.$OecpMetaDataConfig || {}
  let api = get(config, 'api') || ''
  let name = ''
  pathname.substr(1).split('/').forEach((v, i) => {
    name += (i === 0 ? v : firstUpperCase(v))
  })
  let fetchFn = get(api, `fetch.${name}`, apis[name])
  if (!isFunction(fetchFn)) {
    let ApiException = function (message) {
      this.message = message
      this.name = 'ApiException'
    }
    throw new ApiException(`${pathname} 未在 api.js 内注册`)
  }
  return callApi.call(this, {
    filterFn: get(api, `filter.${name}`) || get(api, `defaultFilter`) || defaultFilter,
    fetchFn,
    mappingFn: get(api, `mapping.${name}`) || get(api, `defaultMapping`) || defaultMapping,
    failFn: get(api, `fail.${name}`) || get(api, `defaultFail`),
    query: data || {}
  })
}

export default apis
